/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2024-03-07 16:50:41
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-25 14:49:05
 */
import axios from 'axios'
import QS from 'qs'
let baseURL = ''
// const baseURL = import.meta.env.VITE_APP_BASE_API
if (process.env.NODE_ENV === 'production') {
  baseURL = location.origin + '/officialWeb'
} else {
  baseURL = process.env.VUE_APP_BASE_API
}
// create an axios instance
const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // baseURL: 'http://192.168.20.60:8014', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 0, // request timeout
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if(config.json){
    //   config.headers['Content-Type'] = 'application/json;charset=utf-8'
    // }
    if (config.file) {
      delete config.responseType
      delete config.transformRequest
    } else {
      config.responseType = 'json'
      config.transformRequest = [function (data) {
        return QS.stringify(data) // 利用对应方法转换格式
      }]
    }
    if (QS.parse(config.data).modelType) {
      config.headers.module = QS.parse(config.data).modelType
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // console.log(res)
    // console.log(response)
    if (res.errorCode !== 200) {
      return Promise.reject(new Error(`data_${res.errorMsg || 'Error'}`))
    } else {
      return res.data
    }
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

export default service
